import { useState, useEffect } from "react";
import dispatchService from "services/dispatch.service";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import MDButton from 'components/MDButton';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default function ProvideDeliveryDateDialog({
    open,
    handleClose,
    dispatchData
}) {
    const [dispatch, setDispatch] = useState({});
    const [selOrg, setSelOrg] = useState(null);
    const [errors, setErrors] = useState({});

    // Load the dispatch data when it changes
    useEffect(() => {
        if (dispatchData) {
            const newDispatchData = { ...dispatchData };
            const adapter = new AdapterDayjs();

            newDispatchData.actual_delivery_date = adapter.date(newDispatchData.actual_delivery_date);
            setDispatch(newDispatchData);
        }
    }, [dispatchData]);

    // Handles individual field updates to the new order's state
    const changeHandler = (e) => {
        const { name, value } = e.target;
        setDispatch({
            ...dispatch,
            [name]: value
        });
    }

    // Handles batch updates to the new order's state
    const batchChangeHandler = (updates) => {
        setDispatch({
            ...dispatch,
            ...updates
        })
    }

    // Handles the cancellation of the create order dialog
    const handleCancel = () => {
        setDispatch({});
        setSelOrg(null);
        setErrors({});
        handleClose();
    }

    // Handles the submission of the create order form
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setErrors({});

            if (!dispatch.actual_delivery_date) {
                setErrors({ actual_delivery_date: "Delivery date is required." });
                return;
            }

            const payload = {
                data: {
                    attributes: {
                        status: "Scheduled",
                        actualDeliveryDate: dispatch.actual_delivery_date,
                    }
                }
            }

            await dispatchService.updateDispatchStatus(dispatch.id, payload);

            setDispatch({});
            setSelOrg(null);
            handleClose({ reload: true });

        } catch (error) {
            console.error("Error creating order: ", error);
        }

    }

    return (
        <Dialog open={open} onClose={handleCancel}>

            {/* Dialog Title and Context */}
            <DialogTitle> Provide Delivery Date</DialogTitle>
            <DialogContent>

                <DialogContentText>
                    Please Input the delivery date below.
                </DialogContentText>

                {/* Form for Creating the Order */}
                <form onSubmit={handleSubmit} id="subscription-form">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Delivery Date"
                                    value={dispatch.actual_delivery_date || null}
                                    onChange={(newValue) => {
                                        batchChangeHandler({ actual_delivery_date: newValue });
                                    }}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            error: errors.actual_delivery_date ? true : false,
                                            helperText: errors.actual_delivery_date || "",
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                </form>

            </DialogContent>

            {/* Dialog action buttons */}
            <DialogActions>
                <MDButton
                    color="info"
                    variant="gradient"
                    size="small"
                    onClick={handleCancel}>
                    Cancel
                </MDButton>
                <MDButton
                    color="info"
                    variant="gradient"
                    size="small"
                    type="submit"
                    form="subscription-form">
                    Save
                </MDButton>
            </DialogActions>

        </Dialog >
    );
}
